<template>
  <MoviesChartsBarTemplate
    v-if="chartData"
    id="actor-appearances-chart"
    :chart-data="chartData"
    :chart-options="chartOptions"
    :chart-style="chartStyle"
  />
</template>

<script setup>
  import { computed } from 'vue';
  import { useMovieCharts } from '../../../composables/movie_charts.js';
    
  const metadata = { dataLimit: 20 };
  const { chartData, chartOptions } = useMovieCharts('actors', metadata);
  
  const chartStyle = computed(() => {
    return {
      height: '600px',
      width: `${window.screen.width / 1.5}px`,
    };
  });
</script>